import {Component, inject, ViewChild, OnInit} from '@angular/core';
import {ButtonModule} from 'primeng/button';
import {LayoutService} from "@/core/layout/service/layout.service";
import {VersionInfoComponent} from '@/shared/components/version-info/version-info.component';
import {VersionService} from '@/services/version.service';
import {CommonModule} from '@angular/common';

@Component({
    standalone: true,
    selector: '[app-footer]',
    imports: [ButtonModule, VersionInfoComponent, CommonModule],
    template: ` <span class="font-medium text-lg text-muted-color">
        © {{ currentYear }} Envolve Corp. All rights reserved. Envolve™ is a trademark of Envolve Corp.
        <span class="ml-2 cursor-pointer text-sm hover:underline" (click)="showVersionInfo()">
            v{{ uiVersion }}
        </span>
    </span>
        <app-version-info></app-version-info>`,
    host: {
        class: 'layout-footer'
    }
})
export class AppFooter implements OnInit {
    layoutService = inject(LayoutService);
    versionService = inject(VersionService);
    currentYear: number = new Date().getFullYear();
    uiVersion: string = 'loading...';

    @ViewChild(VersionInfoComponent) versionInfoComponent!: VersionInfoComponent;

    ngOnInit() {
        this.versionService.getUIVersionNumber().subscribe({
            next: (version) => {
                this.uiVersion = version;
            },
            error: (err) => {
                console.error('Failed to load UI version', err);
                this.uiVersion = 'unknown';
            }
        });
    }

    showVersionInfo() {
        this.versionInfoComponent.show();
    }
}
